import { css } from "@emotion/css";
import { useOctopusLinkComponent } from "@octopusdeploy/design-system-components";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import type * as React from "react";
interface ListInternalLinkProps extends React.PropsWithChildren<{}> {
    href: LinkHref;
    accessibleName?: string;
}
export function ListInternalLink({ accessibleName, href, children }: ListInternalLinkProps) {
    const OctopusLink = useOctopusLinkComponent();
    return (<OctopusLink aria-label={accessibleName} className={listInternalLinkStyles} href={href}>
            {children}
        </OctopusLink>);
}
const listInternalLinkStyles = css({
    color: "inherit",
    width: "100%",
    height: "100%",
    display: "block",
    "&:hover": {
        color: "inherit",
    },
});
